import { addAsync as _postAsync } from "../../api";

const BASE_URL = "/session/google";

export const authenticate = async (authCode) => {
    return _postAsync({ url: `${BASE_URL}/auth:authenticate`, data: authCode });
};

export const refreshToken = async (refreshToken) => {
    return _postAsync({ url: `${BASE_URL}/auth:refresh-token`, data: refreshToken });
};
